import { createContext } from 'react';
import { DEFAULT_API_URL } from './constants';
const noop = (_value) => undefined;
export const defaultGlobalContext = {
    apiDescriptionUrl: DEFAULT_API_URL,
    setDescriptionUrl: noop,
};
export const GlobalContext = createContext(defaultGlobalContext);
